const padrao_completo = {
    criar: true,
    deletar: true,
    editar: true,
    visualizar: true
}

const padrao_sem_permissoes = {
    criar: false,
    deletar: false,
    editar: false,
    visualizar: false
}

export const rotasPermissao = {
    diretor: {
        admin: padrao_completo,
        avaliacao: padrao_completo,
        falta: padrao_completo,
        licenca: padrao_completo,
        campanhas: padrao_completo,
        inscricoes: padrao_completo,
        perfis: padrao_completo,
        historicoPerfil: padrao_completo,
        filaInstrumentos: padrao_completo,
        tipoCursos: padrao_completo,
        cursos: padrao_completo,
        turmas: padrao_completo,
        matriculas: padrao_completo,
        periodoMatricula: padrao_completo,
        planejamentos: padrao_completo,
        logs: padrao_sem_permissoes,
        rotas: padrao_sem_permissoes,
        permissoes: padrao_sem_permissoes,
        mensagens: padrao_completo,
    },
    instrutor: {
        admin: padrao_completo,
        avaliacao: padrao_completo,
        falta: padrao_completo,
        licenca: padrao_sem_permissoes,
        campanhas: padrao_sem_permissoes,
        inscricoes: padrao_sem_permissoes,
        perfis: padrao_sem_permissoes,
        historicoPerfil: padrao_sem_permissoes,
        filaInstrumentos: padrao_sem_permissoes,
        tipoCursos: padrao_sem_permissoes,
        cursos: padrao_sem_permissoes,
        turmas: padrao_sem_permissoes,
        matriculas: padrao_sem_permissoes,
        periodoMatricula: padrao_sem_permissoes,
        planejamentos: padrao_completo,
        logs: padrao_sem_permissoes,
        rotas: padrao_sem_permissoes,
        permissoes: padrao_sem_permissoes,
        mensagens: padrao_completo,
    }
}

export const permissions_check = (rota, permissao, permissoes) => {
    return permissoes[rota]?.[permissao];
}